"use client";

import React, { useState } from "react";
import { MapPin } from "lucide-react";
import { Badge } from "@/components/ui/badge";
const cities = [{
  id: "burlington",
  name: "Burlington",
  path: "M 150 50 Q 220 40 280 70 Q 300 120 250 180 Q 180 200 120 150 Q 100 100 150 50 Z",
  hotspot: {
    left: "50%",
    top: "27.5%"
  }
}, {
  id: "alamance-county",
  name: "Alamance County",
  path: "M 80 160 Q 130 150 180 190 Q 200 250 150 320 Q 100 340 50 280 Q 30 220 80 160 Z",
  hotspot: {
    left: "28.75%",
    top: "60%"
  }
}, {
  id: "piedmont-triad",
  name: "Piedmont Triad",
  path: "M 260 120 Q 320 110 380 150 Q 400 210 350 280 Q 290 300 220 240 Q 200 180 260 120 Z",
  hotspot: {
    left: "75%",
    top: "50%"
  }
}, {
  id: "elon",
  name: "Elon",
  path: "M 120 80 Q 150 70 180 90 Q 190 120 160 150 Q 130 160 100 130 Q 90 100 120 80 Z",
  hotspot: {
    left: "35%",
    top: "30%"
  }
}, {
  id: "guilford-county",
  name: "Guilford County",
  path: "M 40 100 Q 80 90 120 120 Q 130 180 90 240 Q 50 250 20 190 Q 10 130 40 100 Z",
  hotspot: {
    left: "15%",
    top: "45%"
  }
}, {
  id: "mebane",
  name: "Mebane",
  path: "M 300 60 Q 340 50 370 80 Q 380 120 350 150 Q 310 160 280 130 Q 270 90 300 60 Z",
  hotspot: {
    left: "82%",
    top: "25%"
  }
}, {
  id: "north-carolina",
  name: "All of North Carolina",
  path: "M 50 350 Q 150 330 250 350 Q 350 370 380 330 Q 350 280 250 300 Q 150 280 50 320 Z",
  hotspot: {
    left: "50%",
    top: "85%"
  }
}];
export default function ServiceAreas() {
  const [hoveredCity, setHoveredCity] = useState<string | null>(null);
  return <section data-section-id="234248" id="where-we-work" className="relative w-full bg-background text-foreground py-24 overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute -top-[20%] -left-[10%] w-[50%] h-[50%] rounded-lg bg-primary/10 blur-[100px]" />
        <div className="absolute top-[60%] -right-[10%] w-[40%] h-[60%] rounded-lg bg-secondary/10 blur-[120px]" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          
          {}
          <div className="relative w-full max-w-lg mx-auto lg:mx-0 aspect-square">
            <div className="absolute inset-0 bg-card/60 backdrop-blur-md border border-border/50 rounded-2xl shadow-xl overflow-hidden flex items-center justify-center">
              {}
              <div className="absolute inset-0 opacity-[0.05] pointer-events-none" style={{
              backgroundImage: 'radial-gradient(circle at 2px 2px, currentColor 1px, transparent 0)',
              backgroundSize: '24px 24px'
            }} />
              
              <svg viewBox="0 0 400 400" className="w-full h-full drop-shadow-md" xmlns="http://www.w3.org/2000/svg">
                {cities.map((city, i) => <path key={`path-${city.id}`} data-index={i} d={city.path} className={`transition-all duration-500 ease-out cursor-pointer ${hoveredCity === city.id ? "fill-primary/30 stroke-primary stroke-[4px]" : hoveredCity ? "fill-muted/40 stroke-border stroke-2 opacity-40" : "fill-secondary/10 stroke-secondary/30 stroke-2 hover:fill-primary/20"}`} onMouseEnter={() => setHoveredCity(city.id)} onMouseLeave={() => setHoveredCity(null)} />)}
              </svg>

              {}
              {cities.map((city, i) => <div key={`hotspot-${city.id}`} data-index={i} className="absolute w-4 h-4 -ml-2 -mt-2 transition-transform duration-300" style={{
              left: city.hotspot.left,
              top: city.hotspot.top,
              transform: hoveredCity === city.id ? 'scale(1.3)' : 'scale(1)'
            }} onMouseEnter={() => setHoveredCity(city.id)} onMouseLeave={() => setHoveredCity(null)}>
                  <div className={`absolute inset-0 rounded-lg ${hoveredCity === city.id ? 'bg-primary' : 'bg-primary/90'}`} />
                  <div className={`absolute inset-0 rounded-lg bg-primary animate-ping ${hoveredCity === city.id ? 'opacity-100' : 'opacity-50'}`} />
                </div>)}
            </div>
          </div>

          {}
          <div className="flex flex-col justify-center space-y-8">
            <div className="space-y-4">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-secondary tracking-tight">
                Where We Work
              </h2>
              <p className="text-lg text-muted-foreground max-w-xl font-default leading-relaxed">Chipper Mulching Co. is proud to serve Burlington, NC, Gibsonville, NC, Elon, NC, Whitsett, NC, Snow Camp, NC, Mebane, NC, and the entire Piedmont Triad. Our specialized equipment allows us to reach properties across the region, providing low-impact land clearing solutions.</p>
            </div>

            <div className="space-y-6">
              <h3 className="text-sm font-default font-bold text-secondary uppercase tracking-widest">
                Our Service Territory
              </h3>
              <div className="flex flex-wrap gap-3">
                {cities.map((city, i) => <Badge key={`badge-${city.id}`} data-index={i} variant={hoveredCity === city.id ? "default" : "outline"} className={`text-sm md:text-base py-3 px-6 cursor-pointer transition-all duration-300 border-secondary/20 shadow-md rounded-lg ${hoveredCity === city.id ? "bg-primary text-primary-foreground scale-105 shadow-lg shadow-primary/30" : "bg-card hover:border-primary hover:bg-primary/5 text-secondary"}`} onMouseEnter={() => setHoveredCity(city.id)} onMouseLeave={() => setHoveredCity(null)}>
                    <MapPin className={`w-4 h-4 mr-2 transition-colors ${hoveredCity === city.id ? "text-primary-foreground" : "text-primary"}`} />
                    {city.name}
                  </Badge>)}
              </div>
            </div>
            
            <div className="pt-6 border-t border-border/50">
              <p className="text-sm text-muted-foreground font-default italic">Don't see your area listed? Reach out to our team to discuss your project location and see if we can bring our mulching services to you.</p>
            </div>
          </div>

        </div>
      </div>
    </section>;
}